// extracted by mini-css-extract-plugin
module.exports = {"backdropClassNameListStudent":"BaseModalSelectedStudentV2_backdropClassNameListStudent__3hhmn"};